"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteInformationSaveRequest = void 0;
var CompleteInformationSaveRequest = /** @class */ (function () {
    function CompleteInformationSaveRequest() {
    }
    return CompleteInformationSaveRequest;
}());
exports.CompleteInformationSaveRequest = CompleteInformationSaveRequest;
;
//# sourceMappingURL=completeInformationSave.request.js.map